import React from 'react';
import {Button, Flex, Input, Typography} from 'antd';
import {useCSContext} from 'Context/ContentStackContext';
import DialogWrapper from './DialogWrapper';
import {CSUIDList} from 'Utils/constants/CSclientMapping';
import styles from './styles';
import {GIFTING} from '../../giftingConstants';

interface IProps {
  loading: boolean;
  openGiftingDialog: boolean;
  setOpenGiftingDialog: any;
  handleSubmitGift: any;
  customerEmail: any;
  manualEmailEntry: string;
  setManualEmailEntry: any;
}

function GiftDialog(props: IProps) {
  const {
    openGiftingDialog,
    setOpenGiftingDialog,
    handleSubmitGift,
    customerEmail,
    loading,
    manualEmailEntry,
  } = props;
  const {artifacts} = useCSContext(CSUIDList);

  return (
    <DialogWrapper closeDialogMethod={setOpenGiftingDialog} open={openGiftingDialog}>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
        <Flex vertical gap={16} style={{paddingBottom: 8}}>
          <img src={artifacts.gift_icon} alt="" style={{fontSize: 70, alignSelf: 'center'}} />
          <Typography.Title level={3} style={{textAlign: 'center', margin: 0}}>
            {GIFTING.gifting_dialog.heading}
          </Typography.Title>
          <Typography.Text>{GIFTING.gifting_dialog.subtitle}</Typography.Text>
        </Flex>
        <Typography.Text style={{display: 'block', padding: '8px 0'}}>
          {GIFTING.gifting_dialog.email_label}
        </Typography.Text>
        <Input value={customerEmail} disabled />
      </div>
      <div style={styles.buttonBox}>
        <Button
          disabled={!customerEmail && !manualEmailEntry}
          onClick={handleSubmitGift}
          style={styles.button}
          type="primary"
          loading={loading}>
          {GIFTING.gifting_dialog.button_text}
        </Button>
      </div>
    </DialogWrapper>
  );
}

export default GiftDialog;
